import { ITopologyConfigurationBuilderBase } from "./ITopologyConfigurationBuilderBase.js";

export interface IOrchestratorTopologyConfigurationBuilder extends ITopologyConfigurationBuilderBase<IOrchestratorTopologyConfigurationBuilder> {

}
